<template>
  <b-modal
    id="transfer-nganluong-modal"
    v-model="visible"
    title="Thông tin hợp đồng chuyển đổi"
    centered
    size="md"
    @hidden="resetForm"
  >
    <ValidationObserver ref="observer">
      <b-form @submit.prevent>
        <b-form-group>
          <template #label>Ngày ký<span class="text-danger">*</span></template>
          <ValidationProvider rules="required" name="Ngày ký" v-slot="{ errors }">
            <b-form-input
              v-model="form.dateSign"
              type="date"
              placeholder="Chọn ngày ký"
              style="width: 100%"
              :state="errors.length > 0 ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>

        <b-form-group>
          <template #label>Mã Hợp đồng Ngân lượng<span class="text-danger">*</span></template>
          <ValidationProvider rules="required" name="Mã hợp đồng" v-slot="{ errors }">
            <b-form-input
              v-model="form.code"
              placeholder="Nhập mã hợp đồng"
              :state="errors.length > 0 ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
        <b-form-group>
          <!-- <template #label>Tình trạng ký <span class="text-danger">*</span></template> -->
          <ValidationProvider rules="required" name="Tình trạng ký" v-slot="{ errors }">
            <div class="row">
              <div class="col-6">
                <b-form-radio v-model="form.signOption" value="MERCHANT_SIGNED">
                  <span style="font-size: 14px; line-height: 2; cursor: pointer"
                    >Merchant đã ký</span
                  >
                </b-form-radio>
              </div>
              <div class="col-6">
                <b-form-radio v-model="form.signOption" value="MERCHANT_AND_COMPANY_SIGNED">
                  <span style="font-size: 14px; line-height: 2; cursor: pointer"
                    >MC và Công ty đã ký</span
                  >
                </b-form-radio>
              </div>
            </div>
            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
        <b-form-group>
          <template #label>File hợp đồng<span class="text-danger">*</span></template>
          <ValidationProvider rules="required" name="File hợp đồng" v-slot="{ errors }">
            <input type="text" v-model="form.contractS3URL[0]" class="d-none" />
            <div
              class="upload-box d-flex flex-column align-items-center justify-content-center cursor-pointer"
              @click="$refs.fileInput.click()"
              :class="{ 'border-danger': errors.length > 0 }"
              style="
                border: 1px dashed #007bff;
                border-radius: 8px;
                padding: 20px;
                background: #ebf5ff;
              "
            >
              <i class="bx bx-upload text-primary" style="font-size: 24px"></i>
              <span v-if="!selectedFile" class="text-secondary mt-2">Tải tệp lên</span>
              <span v-else class="text-success mt-2">Đã chọn tệp</span>
              <input
                type="file"
                ref="fileInput"
                class="d-none"
                accept=".pdf,.png,.jpg,.jpeg"
                @change="handleFileUpload"
              />
            </div>
            <div v-if="fileName" class="mt-2 text-primary">{{ fileName }}</div>
            <b-form-invalid-feedback
              :state="errors.length > 0 ? false : null"
              style="display: block"
            >
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
      </b-form>
    </ValidationObserver>

    <template #modal-footer>
      <b-button variant="primary" @click="submit" :disabled="loading">
        <b-spinner small v-if="loading"></b-spinner>
        Xác nhận
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { CommonService } from '@/services/common.service'
  import { ContractService } from '@/services/contract.service'
  import mxActions from '../mxActions'

  export default {
    mixins: [mxActions],
    props: {
      contractId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
        loading: false,
        fileName: '',
        selectedFile: null,
        signOptionList: [
          { value: 'MERCHANT_SIGNED', text: 'Merchant đã ký' },
          { value: 'MERCHANT_AND_COMPANY_SIGNED', text: 'MC và Công ty đã ký' },
        ],
        form: {
          dateSign: null,
          code: '',
          contractS3URL: [],
          signOption: 'MERCHANT_SIGNED',
        },
      }
    },
    methods: {
      show() {
        this.visible = true
      },
      hide() {
        this.visible = false
      },
      resetForm() {
        this.form = {
          dateSign: null,
          code: '',
          contractS3URL: [],
          signOption: 'MERCHANT_SIGNED',
        }
        this.fileName = ''
        this.selectedFile = null
        if (this.$refs.observer) {
          this.$refs.observer.reset()
        }
      },
      async handleFileUpload(event) {
        const file = event.target.files[0]
        if (!file) return

        this.fileName = file.name
        this.selectedFile = file
        this.form.contractS3URL = [file.name] // Dummy value for validation
        this.$refs.fileInput.value = ''
      },
      async submit() {
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return

        try {
          this.loading = true

          // 1. Upload file to S3 first
          const formData = new FormData()
          formData.append('files', this.selectedFile)
          formData.append('folderName', 'NextCrm')
          const uploadResponse = await CommonService.uploadFile(formData)

          if (uploadResponse.code !== 1000) {
            this.showFailMx(uploadResponse.message || 'Lỗi upload file')
            this.loading = false
            return
          }

          const urlFile = uploadResponse.data
          this.form.contractS3URL = [urlFile[0]]

          // 2. Map payload and push to Contract API
          const payload = {
            contractId: this.contractId,
            code: this.form.code,
            dateSign: this.form.dateSign ? new Date(this.form.dateSign).getTime() : null,
            contractS3URL: this.form.contractS3URL,
            signOption: this.form.signOption,
          }

          const response = await ContractService.transferToNganLuongContract(payload)
          if (response.code === 1000 || response.result) {
            this.showSuccessMx('Gửi yêu cầu chuyển đổi ngân lượng thành công')
            this.$emit('success')
            this.hide()
          } else {
            this.showFailMx(response.message || 'Gửi yêu cầu chuyển đổi ngân lượng thất bại')
          }
        } catch (error) {
          console.error(error)
          this.showFailMx(error.message || 'Gửi yêu cầu chuyển đổi ngân lượng thất bại')
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
  .upload-box {
    transition: all 0.3s;
  }

  .upload-box:hover {
    background: #e0f0ff !important;
  }
</style>

<style>
  /* Fix z-index for ElementUI date picker dropdown inside Bootstrap modal */
  .el-picker-panel,
  .el-select-dropdown {
    z-index: 9999 !important;
  }
</style>
